// extracted by mini-css-extract-plugin
export default {"card":"b1-z"};